/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CreateCustomersFromOrdersErrorDtoBase
 * auto generated base class for the model CreateCustomersFromOrdersErrorDtoModel.
 */
export const CreateCustomersFromOrdersErrorDtoModelBase = ModelBase
  .named('CreateCustomersFromOrdersErrorDto')
  .props({
    __typename: types.optional(types.literal("CreateCustomersFromOrdersErrorDto"), "CreateCustomersFromOrdersErrorDto"),
    code: types.union(types.undefined, types.string),
    message: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CreateCustomersFromOrdersErrorDtoModelSelector extends QueryBuilder {
  get code() { return this.__attr(`code`) }
  get message() { return this.__attr(`message`) }
}
export function selectFromCreateCustomersFromOrdersErrorDto() {
  return new CreateCustomersFromOrdersErrorDtoModelSelector()
}

export const createCustomersFromOrdersErrorDtoModelPrimitives = selectFromCreateCustomersFromOrdersErrorDto().code.message
